import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { GUTTER } from '../../settings';
import { BREAKPOINTS } from '../../settings';

const Layout = ({ image, name, children, showName, footerImage }) => {

  return (
    <Wrapper>
      {image ? <HeroImage src={image} alt="" /> : null}
      <Content>
        { showName ? <Name>{name}</Name> : null }
        <Paper>
          {children}
        </Paper>
      </Content>
      {footerImage ? <FooterImage src={footerImage} alt="" /> : null}
    </Wrapper>
  );
};

Layout.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.node,
  showName: PropTypes.bool,
  footerImage: PropTypes.string,
};

const Wrapper = styled.div`
  position: relative;
  max-width: 1024px;
  margin: 0rem auto;
`;

const HeroImage = styled.img`
  height: auto;
  max-width: none;
  position: absolute;
  width: 100%;
`;

const FooterImage = styled.img`
  margin-top: 40px;
  margin: 0rem auto;
  width: 100%;
  padding-inline: 16px;

  @media (min-width: ${BREAKPOINTS.sm}) {
    padding-inline: 32px;
  }
`;

const Content = styled.div`
  position: relative;
`;

const Paper = styled.div`
  border-radius: 10px 10px 0 0;
  padding: 16px;

  @media (min-width: ${BREAKPOINTS.sm}) {
    margin: 0 16px;
  }

  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;

const Name = styled.span`
  display: block;
  font-size: 2.8rem;
  font-weight: bold;
  letter-spacing: 3px;
  margin: 0 ${GUTTER};
  min-height: 250px;
  padding: 40px 0;
  text-align: center;
  text-transform: uppercase;
`;

export default Layout;
